import React from "react";

const Body = (props: any) => {
  return (
    <div className="ct-main-container ct-mx-auto">
      {props.children}
    </div>
  );
};

export default Body;
